import {
  Attendance,
  CreatePreCheckout,
  PreCheckoutDetails,
  PreCheckoutForm,
  PreCheckoutLocalStorage,
} from 'interfaces/event';
import * as Rx from 'rxjs';
import preCheckoutService from 'services/PreCheckout';

class CreatePreCheckoutService {
  private formartValues = (values: PreCheckoutForm, transaction_key: string): CreatePreCheckout => {
    const attendances: Attendance[] = values.products.map(item => {
      delete item.ticket_name;
      return item;
    });

    return {
      attendances,
      transaction_key,
    };
  };

  public createPreCheckout = (values: PreCheckoutForm, transaction_key: string): Rx.Observable<any> => {
    const formatedValues = this.formartValues(values, transaction_key);
    return preCheckoutService.create(formatedValues);
  };

  public saveDataOnLocalStorage = (values: PreCheckoutLocalStorage): void => {
    localStorage.setItem('preCheckoutDetails', JSON.stringify(values));
  };

  public getDataFromLocalStorage = (): PreCheckoutLocalStorage => {
    const data = JSON.parse(localStorage.getItem('preCheckoutDetails'));
    return data;
  };

  public compareDataWithLocalStorage = (values: PreCheckoutDetails): boolean => {
    const localStorageData: PreCheckoutLocalStorage = JSON.parse(localStorage.getItem('preCheckoutDetails'));
    if (
      !localStorageData ||
      !localStorageData.preCheckoutDetails ||
      !localStorageData.products ||
      !values.products.length
    ) {
      return false;
    }

    if (localStorageData.preCheckoutDetails.event_name !== values.event_name) {
      return false;
    }

    return true;
  };

  public deleteDataFromLocalStorage = (): void => {
    localStorage.removeItem('preCheckoutDetails');
  };
}

export default CreatePreCheckoutService;
